export default {
  home: () => {
    return '/tour';
  },
};
